<div class="vp-home">
  <section class="vp-hero vp-hero-slider" aria-label="Featured photography">
    <div class="vp-hero-slide vp-hero-slide--yoga" aria-hidden="true"><img src="/assets/photography/yoga/yoga-27.webp"
        alt="" width="auto" height="100%" loading="eager" decoding="async" /></div>
    <div class="vp-hero-slide vp-hero-slide--portrait" aria-hidden="true"><img
        src="/assets/photography/wedding/wedding-11.webp" alt="" loading="lazy" decoding="async" /></div>
    <div class="vp-hero-slide vp-hero-slide--wedding" aria-hidden="true"><img
        src="/assets/photography/yoga/yoga-05.webp" alt="" width="auto" height="100%" loading="eager"
        fetchpriority="high" decoding="async" /></div>
    <div class="vp-hero-shade"></div>
    <div class="vp-hero-copy">
      <p class="vp-eyebrow">VISHWAS FOTOGRAPHY <span>· MYSURU, INDIA</span></p>
      <h1>Stories<br />in <em>every frame.</em></h1>
      <p class="vp-hero-description">Honest, thoughtful photography shaped by light, movement and the moments that
        matter — from yoga to wedding celebrations.</p>
      <a routerLink="/photography" class="vp-button">EXPLORE THE WORK <span>→</span></a>
    </div>
    <div class="vp-hero-bottom"><span>01 — 03</span><span class="vp-hero-line"></span><span>YOGA · WEDDINGS ·
        BRAND</span></div>
  </section>

  <section class="vp-work section-pad section-light">
    <div class="vp-container">
      <div class="vp-work-intro">
        <div>
          <p class="vp-eyebrow">THE WORK</p>
          <h2>Photography with a human point of view.</h2>
        </div>
        <div class="vp-work-copy">
          <p>Thoughtful stories shaped by light, movement and connection. Explore selected photographs and the two
            worlds Vishwas Fotography works in: Yoga and Weddings.</p><a routerLink="/photography"
            class="vp-text-link">EXPLORE ALL PHOTOGRAPHY <span>→</span></a>
        </div>
      </div>
      <div class="vp-selected-grid">@for (image of selectedWork; track image) {<a routerLink="/photography"
          class="vp-selected-image"><img [src]="image" alt="Selected work by Vishwas Fotography" loading="lazy" /></a>}
      </div>
      <div class="vp-work-categories">@for (category of categories; track category.slug) { @if (category.available) {<a
          class="vp-category-card" [routerLink]="'/photography/' + category.slug"
          [attr.aria-label]="category.name + ' photography'"><img [src]="category.image"
            [alt]="category.name + ' photography'" loading="lazy" />
          <div class="vp-category-overlay"></div>
          <div class="vp-category-content"><span>PHOTOGRAPHY</span>
            <h3>{{ category.name }}</h3>
            <p>{{ category.description }}</p><strong>VIEW WORK →</strong>
          </div>
        </a>} }</div>
    </div>
  </section>

  <!-- WHY US — original Why Us layout -->
  <section class="section-full mobile-page-padding p-t80 p-b50 bg-gray vp-why-original">
    <div class="section-content">
      <div class="container">
        <div class="section-head">
          <div class="sx-separator-outer separator-left">
            <div class="sx-separator bg-white bg-moving bg-repeat-x"
              style="background-image:url(assets/images/background/cross-line2.png)">
              <h3 class="sep-line-one">Why US?</h3>
            </div>
          </div>
        </div>

        <div class="vp-why-statement">
          <h3>Thoughtful photography, from seeing to finishing.</h3>
          <p>The craft behind every photograph is a combination of light, composition, technical knowledge and creative
            vision.</p>
        </div>

        <div class="row">
          @for (object of whyUs; track object.serial) {
          <div class="col-lg-4 col-md-6 col-sm-12 m-b30">
            <div class="sx-icon-box-wraper icon-count-2-outer">
              <div class="icon-count-2 bg-white">
                <span class="vp-card-serial" aria-hidden="true">{{ object.serial }}</span>
                <div class="icon-xl inline-icon m-b5 scale-in-center">
                  <span class="icon-cell">
                    <img [src]="object.image" [alt]="object.title" loading="lazy" decoding="async" width="100"
                      height="100" />
                  </span>
                </div>
                <div class="icon-content">
                  <h4 class="sx-tilte">{{ object.title }}</h4>
                  <p>{{ object.description }}</p>
                </div>
              </div>
            </div>
          </div>
          }
        </div>

      </div>
    </div>
    <div class="hilite-title text-left p-l50 text-uppercase vp-expertise-side" aria-hidden="true">
      <strong>EXPERTISE</strong>
    </div>
  </section>

  <!-- TESTIMONIAL — original Yoga by Vishwas layout -->
  <section class="section-full container-fluid vp-original-testimonials">
    <div class="section-content">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 bg-gray bg-cover bg-no-repeat vp-original-experience"
          style="background-image:url(/assets/portfolio/2.webp)">
          <div class="sx-left-part mobile-page-padding">
            <div class="section-head">
              <div class="sx-separator-outer separator-left">
                <div class="sx-separator bg-white bg-moving bg-repeat-x"
                  style="background-image:url(assets/images/background/cross-line2.png)">
                  <h3 class="sep-line-one">{{ experience.title }}</h3>
                </div>
              </div>
            </div>
            <div class="counter-blocks">
              <div class="row">
                @for (object of experience.items; track object.title) {
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 m-b30">
                  <div class="sx-count text-black sx-icon-box-wraper bg-repeat bg-white p-a30"
                    style="background-image:url(assets/images/background/bg-5.png)">
                    <h2 class="st-count-number sx-text-primary text-left"><span class="counter">{{ object.count
                        }}</span></h2>
                    <h4 class="m-tb0">{{ object.title }}</h4>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6 col-lg-6 col-md-12 bg-white bg-repeat vp-original-testimonial-panel"
          style="background-image:url(assets/images/background/bg-12.jpg)">
          <div class="sx-right-part mobile-page-padding p-t80 p-b50">
            <div class="section-head">
              <div class="sx-separator-outer separator-left">
                <div class="sx-separator bg-white bg-moving bg-repeat-x"
                  style="background-image:url(assets/images/background/cross-line2.png)">
                  <h3 class="sep-line-one">Testimonial</h3>
                </div>
              </div>
            </div>

            <div class="testimonial-home vp-original-testimonial-carousel">
              @for (object of [testimonials[activeTestimonial]]; track object.name) {
              <div class="item">
                <div class="testimonial-2 hover-animation-1">
                  <div class="testimonial-detail clearfix">
                    <h4 class="testimonial-name">{{ object.name }}</h4>
                    <a target="_blank" rel="noopener" [href]="object.link"><img style="width:70px"
                        src="assets/images/google-logo.png" alt="Google review" width="70" height="24" loading="lazy"
                        decoding="async"></a>
                    <span class="testimonial-position">Yoga photography client</span>
                    <span class="fa fa-quote-right"></span>
                  </div>
                  <div class="testimonial-text bg-white shadow-sm">
                    <p>{{ object.quote }}</p>
                  </div>
                </div>
              </div>
              }
              <div class="vp-testimonial-controls" aria-label="Testimonial navigation">
                <button type="button" (click)="previousTestimonial()" aria-label="Previous testimonial">←</button>
                <span>{{ activeTestimonial + 1 }} / {{ testimonials.length }}</span>
                <button type="button" (click)="nextTestimonial()" aria-label="Next testimonial">→</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="vp-film-section section-pad">
    <div class="vp-container">
      <div class="vp-film-heading">
        <div>
          <p class="vp-eyebrow">IN MOTION</p>
          <h2>Some stories are<br /><em>best experienced.</em></h2>
        </div>
        <p>A closer look at the practice, the presence and the person behind the movement.</p>
      </div>
      <div #videoBox class="vp-film-frame video-section-full bg-no-repeat bg-cover bg-center overlay-wraper"
        role="group" aria-label="Journey of Laruga film"
        style="background-image:url('https://i3.ytimg.com/vi/p0kAK5mR9JU/hqdefault.jpg')">
        <div class="vp-film-overlay overlay-main bg-black" aria-hidden="true"></div>
        <div class="vp-film-inner video-section-inner">
          <div class="vp-film-content video-section-content">
            <a class="vp-film-play play-now" href="https://www.youtube-nocookie.com/embed/p0kAK5mR9JU?autoplay=1"
              (click)="playVideo($event, 'p0kAK5mR9JU')" aria-label="Play Journey of Laruga video"><span
                class="vp-film-play-icon" aria-hidden="true">▶</span><span class="vp-film-ripple"
                aria-hidden="true"></span></a>
            <div class="vp-film-caption video-section-bottom"><span>FEATURED FILM · YOGA</span>
              <h3>Journey<br />of Laruga</h3>
            </div>
            <p class="vp-film-tagline">Movement. Discipline. Stillness.</p>
            <span class="vp-film-duration">WATCH FILM</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="vp-about section-pad">
    <div class="vp-container vp-about-grid">
      <div class="vp-about-image"><img src="/assets/photography/wedding/wedding-10.webp"
          alt="Wedding photograph by Vishwas Fotography" loading="lazy" /></div>
      <div class="vp-about-copy">
        <p class="vp-eyebrow">ABOUT VISHWAS</p>
        <h2>Photography is about noticing the moment.</h2>
        <p>Whether it is the quiet concentration of a yoga practice or the energy of a wedding celebration, the aim is
          the same: make photographs that feel honest, distinctive and worth returning to.</p>
        <p>Based in Mysuru and working across Bengaluru and beyond.</p><a routerLink="/photography"
          class="vp-button vp-button--dark">EXPLORE THE PORTFOLIO <span>→</span></a>
      </div>
    </div>
  </section>

  <section class="vp-cta">
    <div class="vp-container vp-cta-inner">
      <div>
        <p class="vp-eyebrow">FOLLOW THE WORK</p>
        <h2>@vishwasfotography</h2>
        <p>More recent work, behind the scenes and photography updates on Instagram.</p>
      </div>
      <div class="vp-cta-actions"><a href="https://www.instagram.com/vishwasfotography/" target="_blank" rel="noopener"
          class="vp-button">FOLLOW ON INSTAGRAM</a><a routerLink="/contact"
          class="vp-text-link vp-text-link--light">START A CONVERSATION <span>→</span></a></div>
    </div>
  </section>
</div>